import React, { FunctionComponent } from 'react';

import { Grid } from '../Grid';
import { BasePaginationContainer } from '../BasePaginationContainer/BasePaginationContainer';
import ShowAllContainer from '../ShowAllContainer/ShowAllContainer';
import { BaseDashboardSection } from '../BaseDashboardSection/BaseDashboardSection';
import { IDashboardSectionProps } from './DashboardSection.types';

export const DashboardSection: FunctionComponent<IDashboardSectionProps> = props => {
  const { children, contentTitle, itemsName, minColWidth, className, maxItems, ...otherProps } = props;

  return (
    <BaseDashboardSection {...otherProps} className={className}>
      <BasePaginationContainer headingText={contentTitle} itemsName={itemsName}>
        <Grid minColWidth={minColWidth} className={className}>
          <ShowAllContainer itemsPerPage={maxItems}>{children}</ShowAllContainer>
        </Grid>
      </BasePaginationContainer>
    </BaseDashboardSection>
  );
};

export default DashboardSection;
